import { render, staticRenderFns } from "./headerCustom.vue?vue&type=template&id=009d5295&scoped=true&"
import script from "./headerCustom.vue?vue&type=script&lang=js&"
export * from "./headerCustom.vue?vue&type=script&lang=js&"
import style0 from "./headerCustom.vue?vue&type=style&index=0&id=009d5295&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d5295",
  null
  
)

export default component.exports